import $ from "jquery"
import aq from "append-query"
//import text from './Legal'

const bathus_server_url = "api";

class Server {

  signAgreement = (token, agreement, agree, callback, err) => {
    $.ajax({
      url: bathus_server_url + '/rest/user/agreements/' + agreement.code,
      type: "PUT",
      data: JSON.stringify({
        status: agree
          ? "agree"
          : "reject"
      }),
      contentType: "application/json; charset=utf-8",
      crossDomain: true,
      dataType: "text",
      success: callback,
      headers: {
        Authorization: token
      },
      error: err
    })
  }

  getAgreements = (token, params, callback, err) => {
    $.ajax({
      url: aq(bathus_server_url + '/rest/user/agreements', params),
      headers: {
        Authorization: token
      },
      success: callback,
      error: err
    })
  }

  reset = (email, callback, err) => {
    $.ajax({
      url: bathus_server_url + '/rest/user/reset',
      type: "POST",
      data: JSON.stringify({email: email}),
      contentType: "application/json; charset=utf-8",
      crossDomain: true,
      dataType: "json",
      success: callback,
      error: err
    })
  }

  login = (username, password, callback, err) => {
    $.ajax({
      url: bathus_server_url + '/rest/user/login',
      type: "POST",
      data: JSON.stringify({email: username, password: password}),
      contentType: "application/json; charset=utf-8",
      crossDomain: true,
      dataType: "json",
      success: callback,
      error: err
    })
  }

  loginGoogle = (token, callback, err) => {
    $.ajax({
      url: bathus_server_url + '/rest/user/loginG',
      type: "POST",
      data: JSON.stringify({token: token}),
      contentType: "application/json; charset=utf-8",
      crossDomain: true,
      dataType: "json",
      success: callback,
      error: err
    })
  }

  loginFacebook = (token, callback, err) => {
    $.ajax({
      url: bathus_server_url + '/rest/user/loginFb',
      type: "POST",
      data: JSON.stringify({token: token}),
      contentType: "application/json; charset=utf-8",
      crossDomain: true,
      dataType: "json",
      success: callback,
      error: err
    })
  }

}

/*
var agreements = [
  {
    "id": "1231231",
    "title": "Terms and Conditions",
    "description": "Description of agreement",
    "text": text,
    "status": "blank",
    "channels": "ALL"
  }, {
    "id": "131",
    "title": "Privacy policy",
    "description": "Description of agreement",
    "text": text,
    "status": "blank",
    "channels": "ALL"
  }, {
    "id": "345",
    "title": "Profiling agreement",
    "description": "Description of agreement",
    "text": text,
    "status": "blank",
    "channels": "ALL"
  }, {
    "id": "567",
    "title": "Deals and promotions agreement",
    "description": "Description of agreement",
    "text": text,
    "status": "blank",
    "channels": "ALL"
  }
]
*/

export default Server



// WEBPACK FOOTER //
// ./src/data/Server.js